"use client";

import Link from "next/link";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Navbar } from "@/components/Navbar";
import { useAuthStore } from "@/stores/auth";

export default function DashboardPage() {
  return (
    <ProtectedRoute>
      <Navbar />
      <main className="app-main">
        <div className="page-header">
          <div>
            <h1 className="page-title">Dashboard</h1>
            <p className="page-subtitle">Szybki start do codziennej pracy z przegladami.</p>
          </div>
        </div>
        <DashboardContent />
      </main>
    </ProtectedRoute>
  );
}

function DashboardContent() {
  const user = useAuthStore((s) => s.user);

  return (
    <section data-testid="dashboard-welcome" className="space-y-6">
      <div className="panel panel-pad">
        <h2 className="text-xl font-semibold text-slate-950">Witaj, {user?.name}.</h2>
        <p className="mt-1 text-sm text-slate-500">Zalogowano jako {user?.email}</p>
        <p className="mt-4 max-w-3xl text-sm leading-6 text-slate-600">
          System jest przygotowany do prowadzenia klientow, budynkow, inspekcji, analizy
          zdjec oraz generowania raportow AI w jednym uporzadkowanym miejscu.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        <DashboardCard title="Klienci" text="Baza firm i kontaktow." href="/clients" />
        <DashboardCard title="Budynki" text="Obiekty przypisane do klientow." href="/buildings" />
        <DashboardCard title="Przeglady" text="Inspekcje, zdjecia i raporty." href="/inspections" />
      </div>
    </section>
  );
}

function DashboardCard({ title, text, href }: { title: string; text: string; href: string }) {
  return (
    <Link href={href} className="panel panel-pad block transition hover:-translate-y-0.5 hover:border-blue-200 hover:shadow-lg">
      <h3 className="text-base font-bold text-slate-950">{title}</h3>
      <p className="mt-2 text-sm text-slate-600">{text}</p>
      <span className="mt-4 inline-flex text-sm font-semibold text-blue-700">Otworz</span>
    </Link>
  );
}
